import React from 'react';
import createHighlightedParts from '../../utils/highlightUtils';
import { cn } from '../../lib/utils';

interface HighlightTextProps {
  text: string;
  searchQuery?: string;
  className?: string;
  size?: 'sm' | 'base' | 'lg';
}

export default function HighlightText({
  text,
  searchQuery,
  className,
  size = 'base'
}: HighlightTextProps) {
  const highlightedContent = createHighlightedParts(text, searchQuery);

  const sizeClasses = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg'
  };

  return (
    <span className={cn(sizeClasses[size], className)}>
      {highlightedContent}
    </span>
  );
}
